import {
    SET_LOADING,
    SAVE_DATA,
  } from './constants';
  import { SET_CITY_FILTER, SET_AMOUNT_FILTER } from './constants';

  
  export function setLoading(isLoading) {
    return {
      type: SET_LOADING,
      isLoading,
    };
  }
  
  export function saveData(data) {
    return {
      type: SAVE_DATA,
      data,
    };
  }
 
export function setCityFilter(cityList) {
  return {
    type: SET_CITY_FILTER,
    cityList,
  };
}

export function setAmountFilter(amountList) {
  return {
    type: SET_AMOUNT_FILTER,
    amountList,
  };
}
